/* eslint-env browser */

export default WebSocket
